module.exports = __webpack_public_path__ + "8297bc718a5c7c8af5bdb36073d7ebf0.pdf";